// export const ssr = false;
export const prerender = true;
export const trailingSlash = 'always'

// export const csr = true;
